const en = [
  { title: "About", route: "#about" },
  { title: "Experience", route: "#experience" },
  { title: "Technologies", route: "#tech" },
  { title: "Projects", route: "#projects" },
];

const pt = [
  { title: "Sobre", route: "#about" },
  { title: "Experiência", route: "#experience" },
  { title: "Tecnologias", route: "#tech" },
  { title: "Projetos", route: "#projects" },
];

export const navItemsV2 = { en, pt };
